import { StoreRole } from '../store/store';
import {
   DEFAULT_PERMISSION_ADDED_AT,
   DEFAULT_PERMISSIONS,
   RolePermission,
} from '../models/permission.model';

const BUILT_IN_ROLES = [StoreRole.ADMIN, StoreRole.MANAGER, StoreRole.CASHIER];

/** End of the ship day (Asia/Phnom_Penh): deploys trail the commit, so an edit that day predates it. */
function addedAtMillis(permission: string): number | null {
   const day = DEFAULT_PERMISSION_ADDED_AT[permission];
   return day ? Date.parse(`${day}T23:59:59.999+07:00`) : null;
}

/**
 * Grants a built-in role the defaults it never received because they were added
 * after the store saved its `rolePermissions`. A role the owner never edited
 * (`updatedBy` null) gets every missing default. An edited role only gets
 * defaults added after its last edit — anything older that's missing was
 * visible in the editor and left off on purpose. Custom roles and Owner (`*`)
 * are untouched. In-memory only, like the report-permission expansion; the
 * next save from the permission editor persists it.
 */
export function grantNewDefaultPermissions(rolePerms: RolePermission[]): RolePermission[] {
   if (!Array.isArray(rolePerms)) return rolePerms;
   return rolePerms.map((rp) => {
      const defaults = BUILT_IN_ROLES.find((r) => r === rp.role)
         ? DEFAULT_PERMISSIONS[rp.role as StoreRole]
         : null;
      const perms = rp.permissions ?? [];
      if (!defaults || perms.includes('*')) return rp;

      const editedAt = rp.updatedBy?.timestamp?.toMillis?.() ?? null;
      const missing = defaults.filter((id) => {
         if (perms.includes(id)) return false;
         if (editedAt === null) return true;
         const addedAt = addedAtMillis(id);
         return addedAt !== null && addedAt > editedAt;
      });
      return missing.length ? { ...rp, permissions: [...perms, ...missing] } : rp;
   });
}
